import React, { useState } from "react";
import Inputz from "../ui/atoms/Inputz";
import Buttonz from "../ui/atoms/Buttonz";
import { useDispatch } from "react-redux";
import { validationPopup } from "../redux/actions";
import LogoP from "../ui/atoms/LogoP";
import "../styles/Admin.scss";

function AdminLogin() {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState({
        email: false,
        password: false,
    });

    const dispatch = useDispatch();

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleInputChange = (e) => {
        const { name, value } = e;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleSubmit = () => {
        const { email, password } = formData;
        const emailError = !email || !isValidEmail(email);
        const passwordError = !password;

        if (emailError || passwordError) {
            setErrors({
                email: emailError,
                password: passwordError,
            });

            dispatch(
                validationPopup({
                    message: emailError
                        ? "Please enter a valid email address."
                        : "Please fill in all fields.",
                    icon: "horror",
                    type: "error",
                })
            );
            return;
        }

        // TODO: Implement admin login API call
        dispatch(
            validationPopup({
                message: "Admin login functionality coming soon.",
                icon: "loading_ani",
                type: "info",
            })
        );
    };

    return (
        <div className="admin-login-hero">
            <div className="admin-login-page-box">
                <div className="form-box">
                    <LogoP
                        logo="logo01"
                        hoverLogo="logo03"
                        logoTypeEn="logotype_en"
                        logoTypeJp="logotype_jp"
                        className="admin-login-logo"
                    />
                </div>
                <div className="form-box">
                    <h1>Admin Login</h1>
                </div>
                <div className="form-box">
                    <Inputz
                        iconL="mail"
                        focusL="mail"
                        label="Email"
                        type="email"
                        name="email"
                        placeholder="Admin Email"
                        value={formData.email}
                        onChange={handleInputChange}
                        error={errors.email}
                    />

                    <Inputz
                        iconL="lock"
                        focusL="lock"
                        iconR="eye"
                        focusR="eye"
                        iconOn="eye_on"
                        iconOff="eye_off"
                        label="Password"
                        type="password"
                        name="password"
                        placeholder="Admin Password"
                        value={formData.password}
                        onChange={handleInputChange}
                        error={errors.password}
                    />
   </div>
   <div className="form-box">
                    <Buttonz
                        iconR="login"
                        hoverR="login"
                        label="Login as Admin"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;